import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";

interface Props {
  firstName: string;
  lastName: string;

  onChange: (firstName: string, lastName: string) => void;
  onEnter?: () => void;
  onEsc?: () => void;
  focusOnMount?: boolean;
}

export const UserFirstLastName = (props: Props) => {
  const { firstName, lastName, onChange } = props;

  return (
    <div className="flex gap-small">
      <div className="grow1">
        <RequiredTextInput
          focusOnMount={props.focusOnMount}
          maxLength={serverReference.constants.personName.maxFirstNameLength}
          value={firstName}
          onChange={(value) => onChange(value, lastName)}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
          placeholder={RESX.Contact.FirstNameHelpText}
          validatorKey="firstName"
        />
      </div>
      <div className="grow1">
        <RequiredTextInput
          maxLength={serverReference.constants.personName.maxLastNameLength}
          value={lastName}
          onChange={(value) => onChange(firstName, value)}
          placeholder={RESX.Contact.LastNameHelpText}
          onEnter={props.onEnter}
          onEsc={props.onEsc}
          validatorKey="lastName"
        />
      </div>
    </div>
  );
};